import { Helper } from '../Helper';
export class RawIteratorReduceBaseHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'OVER');
                sb.emitSysCall(node, 'Neo.Enumerator.Next');
            },
            each: (innerOptions) => {
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'SWAP');
                this.each(sb.pushValueOptions(innerOptions));
            },
            handleReturn: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
            },
            cleanup: () => {
                sb.emitOp(node, 'NIP');
                if (!optionsIn.pushValue) {
                    sb.emitOp(node, 'DROP');
                }
            },
        }));
    }
}

//# sourceMappingURL=RawIteratorReduceBaseHelper.js.map
